export default [{
    path: "/app/prices",
    redirect: {
        name: 'prices.manage'
    },
    component: () => import("../../../views/dashboard/customer/PricesComponent.vue"),
    children: [{
        path: "/app/prices/trend",
        name: "prices.trend",
        component: () => import("../../../views/dashboard/customer/prices/TrendComponent.vue"),
        meta: {
            allowedUsers: ['customer']
        }
    }]
}]
